import InverseIcon from "@/src/components/salesforce_components/InverseIcon.vue";
import CrmPropertiesSelect from "@/src/components/salesforce_components/CRMPropertiesSelect.vue";
import CrmStatusesSelect from "@/src/components/salesforce_components/CRMStatusesSelect.vue";
import OverwriteToggle from "@/src/components/salesforce_components/OverwriteToggle.vue";
import APIKeyAccess from "@/src/views/api_keys/APIKeyAccess.vue";

import { imageNames } from "@/src/constants/imageConstants.js";
import HubspotPipelineStage from "@/src/components/integration_components/hubspot/HubspotPipelineStage.vue";

export const salesForceTabs = [
  {
    title: "Contacts",
    selected: imageNames.CONTACTS_SELECTED,
    unselected: imageNames.CONTACTS_UNSELECTED,
  },
  {
    title: "Leads",
    selected: imageNames.LEADS_SELECTED,
    unselected: imageNames.LEADS_UNSELECTED,
  },
  {
    title: "Company",
    selected: imageNames.COMPANIES_SELECTED,
    unselected: imageNames.COMPANIES_UNSELECTED,
  },
  {
    title: "Deal",
    selected: imageNames.DEALS_SELECTED,
    unselected: imageNames.DEALS_UNSELECTED,
  },
  {
    title: "Activities",
    selected: imageNames.CONTACTS_SELECTED,
    unselected: imageNames.CONTACTS_UNSELECTED,
  },
  {
    title: "Authentication",
    selected: imageNames.LOCK_SELECTED,
    unselected: imageNames.LOCK_UNSELECTED,
  },
];

export const hubspotTabs = [
  {
    title: "Contacts",
    selected: imageNames.CONTACTS_SELECTED,
    unselected: imageNames.CONTACTS_UNSELECTED,
  },
  {
    title: "Leads",
    selected: imageNames.LEADS_SELECTED,
    unselected: imageNames.LEADS_UNSELECTED,
  },
  {
    title: "Company",
    selected: imageNames.COMPANIES_SELECTED,
    unselected: imageNames.COMPANIES_UNSELECTED,
  },
  {
    title: "Deal",
    selected: imageNames.DEALS_SELECTED,
    unselected: imageNames.DEALS_UNSELECTED,
  },
  {
    title: "Activities",
    selected: imageNames.CONTACTS_SELECTED,
    unselected: imageNames.CONTACTS_UNSELECTED,
  },
];

export const zohoTabs = [
  {
    title: "Contacts",
    selected: imageNames.CONTACTS_SELECTED,
    unselected: imageNames.CONTACTS_UNSELECTED,
  },
  {
    title: "Leads",
    selected: imageNames.LEADS_SELECTED,
    unselected: imageNames.LEADS_UNSELECTED,
  },
  {
    title: "Company",
    selected: imageNames.COMPANIES_SELECTED,
    unselected: imageNames.COMPANIES_UNSELECTED,
  },
  {
    title: "Deal",
    selected: imageNames.DEALS_SELECTED,
    unselected: imageNames.DEALS_UNSELECTED,
  },
  {
    title: "Activities",
    selected: imageNames.CONTACTS_SELECTED,
    unselected: imageNames.CONTACTS_UNSELECTED,
  },
  {
    title: "Authentication",
    selected: imageNames.SETTING_WHITE,
    unselected: imageNames.SETTINGS_GREY,
  },
];

export const salesforcePropertiesCustomColumnRender = {
  crm_label: CrmPropertiesSelect,
  inverse: InverseIcon,
  overwrite: OverwriteToggle,
};

export const hubspotPropertiesCustomColumnRender = {
  crm_label: CrmPropertiesSelect,
  inverse: InverseIcon,
  overwrite: OverwriteToggle,
};

export const zohoPropertiesCustomColumnRender = {
  crm_label: CrmPropertiesSelect,
  inverse: InverseIcon,
  overwrite: OverwriteToggle,
};

export const salesforcePropertiesHeaders = [
  { label: "SuperAGI Properties", key: "field_label", width: 8 },
  { label: InverseIcon, key: "inverse", width: 1 },
  { label: "Salesforce Properties", key: "crm_label", width: 7 },
  { label: "Overwrite", key: "overwrite", width: 2 },
];

export const hubspotPropertiesHeaders = [
  { label: "SuperAGI Properties", key: "field_label", width: 8 },
  { label: "", key: "inverse", width: 1 },
  { label: "Hubspot Properties", key: "crm_label", width: 7 },
  { label: "Overwrite", key: "overwrite", width: 2 },
];

export const zohoPropertiesHeaders = [
  { label: "SuperAGI Properties", key: "field_label", width: 8 },
  { label: "", key: "inverse", width: 1 },
  { label: "Zoho Properties", key: "crm_label", width: 7 },
  { label: "Overwrite", key: "overwrite", width: 2 },
];

export const salesforceStatusesCustomColumnRender = {
  crm_status: CrmStatusesSelect,
  inverse: InverseIcon,
};

export const salesforceStatusesHeaders = [
  { label: "SuperAGI Statuses", key: "super_sales_status", width: 9 },
  { label: InverseIcon, key: "inverse", width: 1 },
  { label: "Salesforce Statuses", key: "crm_status", width: 8 },
];

export const HubSpotStatusesHeaders = [
  { label: "SuperAGI Statuses", key: "super_sales_status", width: 9 },
  { label: InverseIcon, key: "inverse", width: 1 },
  { label: "HubSpot Statuses", key: "crm_status", width: 8 },
];

export const ZohoStatusesHeaders = [
  { label: "SuperAGI Statuses", key: "super_sales_status", width: 9 },
  { label: InverseIcon, key: "inverse", width: 1 },
  { label: "Zoho Statuses", key: "crm_status", width: 8 },
];

export const apiKeyTableHeaders = [
  { label: "API key name", key: "name", width: 4 },
  { label: "Created by", key: "created_by", width: 3, view: true },
  { label: "Last updated", key: "updated_at", width: 3 },
  { label: "Data Access", key: "is_active", width: 2 },
];

export const apiKeyCustomColumnRender = {
  is_active: APIKeyAccess,
};

export const hubspotPipelineTableHeaders = [
  {
    label: "HubSpot Pipeline Name",
    key: "label",
    width: 4,
  },
  {
    label: "Stages",
    key: "stages",
    width: 8,
  },
];

export const zohoPipelineTableHeaders = [
  { label: "Zoho Pipeline Name", key: "label", width: 4 },
  { label: "Stages", key: "stages", width: 8 },
];

export const hubspotPipelineCustomColumnRender = {
  stages: HubspotPipelineStage,
};
